module.exports = __webpack_public_path__ + "img/IconTrackBranco.ad48dc6a.png";